export * from './tm-design-center-detail';
export * from './tm-design-center-detail.mock';
